// Collisions and ground height.
import { ISLAND } from '../world/island.js';
import { PCH, PLATE, colliders } from '../world/eixample.js';
import { R, S } from './ride.js';
import { cars } from '../vehicles/cars.js';

export let collide, groundHeight;

export function buildPhysics() {
  collide = function collide() {
    let hit = null;
    for (const c of colliders) {
      let nx = 0,
        nz = 0,
        pen;
      if (c.type === 'oct') {
        const lx = S.x - c.cx,
          lz = S.z - c.cz,
          ax = Math.abs(lx),
          az = Math.abs(lz);
        const p1 = c.h + R - ax,
          p2 = c.h + R - az,
          p3 = (2 * c.h - c.ch + R * Math.SQRT2 - ax - az) / Math.SQRT2;
        if (p1 <= 0 || p2 <= 0 || p3 <= 0) continue;
        if (p1 <= p2 && p1 <= p3) {
          pen = p1;
          nx = Math.sign(lx);
        } else if (p2 <= p3) {
          pen = p2;
          nz = Math.sign(lz);
        } else {
          pen = p3;
          nx = Math.sign(lx) / Math.SQRT2;
          nz = Math.sign(lz) / Math.SQRT2;
        }
      } else if (c.type === 'rect') {
        const p = [S.x - (c.x0 - R), c.x1 + R - S.x, S.z - (c.z0 - R), c.z1 + R - S.z],
          m = Math.min(...p);
        if (m <= 0) continue;
        pen = m;
        [nx, nz] = [
          [-1, 0],
          [1, 0],
          [0, -1],
          [0, 1],
        ][p.indexOf(m)];
      } else {
        const dx = S.x - c.cx,
          dz = S.z - c.cz,
          a = c.a + R,
          b = c.b + R,
          e = (dx * dx) / (a * a) + (dz * dz) / (b * b);
        if (e >= 1) continue;
        const k = 1 / Math.sqrt(Math.max(e, 1e-4));
        nx = dx / (a * a);
        nz = dz / (b * b);
        const nl = Math.hypot(nx, nz) || 1;
        S.x = c.cx + dx * k;
        S.z = c.cz + dz * k;
        hit = [nx / nl, nz / nl];
        continue;
      }
      S.x += nx * pen;
      S.z += nz * pen;
      hit = [nx, nz];
    }
    for (const c of cars) {
      if (c.off) continue;
      const n = Math.max(1, Math.round(c.len / 1.4));
      for (let k = 0; k < n; k++) {
        const off = n > 1 ? (k / (n - 1) - 0.5) * (c.len - c.w) : 0;
        const cx = c.g.position.x + Math.sin(c.h) * off,
          cz = c.g.position.z + Math.cos(c.h) * off;
        const dx = S.x - cx,
          dz = S.z - cz,
          d = Math.hypot(dx, dz),
          min = c.w * 0.6 + R;
        if (d < min && d > 1e-4) {
          S.x += (dx / d) * (min - d);
          S.z += (dz / d) * (min - d);
          hit = [dx / d, dz / d];
        }
      }
    }
    const E = ISLAND - 2.5,
      Ez = 61.5;
    if (Math.abs(S.x) > E) {
      hit = [-Math.sign(S.x), 0];
      S.x = Math.sign(S.x) * E;
    }
    if (S.z < -E) {
      hit = [0, 1];
      S.z = -E;
    }
    if (S.z > Ez) {
      hit = [0, -1];
      S.z = Ez;
    }
    if (hit) {
      const into = -(Math.sin(S.th) * hit[0] + Math.cos(S.th) * hit[1]) * Math.sign(S.v);
      if (into > 0) S.v *= Math.max(0, 1 - into * 0.35);
    }
  };
  groundHeight = function groundHeight(x, z) {
    if (z > 51) return Math.max(0, 0.3 - ((z - 51) / 14) * 0.3);
    const ax = Math.abs(x),
      az = Math.abs(z);
    if (ax > 47.25 || az > 47.25 || ax + az > 94.5 - 4.8) return 0.3;
    const gx = Math.round(x / 30) * 30,
      gz = Math.round(z / 30) * 30;
    if (Math.abs(gx) > 30 || Math.abs(gz) > 30) return 0;
    const lx = Math.abs(x - gx),
      lz = Math.abs(z - gz);
    return lx < PLATE / 2 && lz < PLATE / 2 && lx + lz < PLATE - PCH ? 0.3 : 0;
  };
}
